// extracted by mini-css-extract-plugin
export default {"bigImageText":"BigImageText_bigImageText__jugZG"};